<ng-container *ngIf="!isLoggedIn && !isWarmState && isReady">
  <div class="d-flex flex-row login-container">
    <div *ngFor="let item of loginArr">
      <ng-container [ngSwitch]="item.id">
        <div
          *ngSwitchCase="'signup'"
          class="signup-container"
          #signUpCodeContainer
        >
          <a
            (click)="setTrackingObject(item, $event)"
            [attr.href]="item.details?.signupLink"
            class="sign-up btn btn-link"
            id="signup-button"
          >
            {{ item.details?.signupLabel }}
          </a>

          <idp-error-tooltip
            class="signUpTooltip"
            (closeFullPopUp)="closeSignUpTooltipPopup($event)"
            *ngIf="!isToolTipisHidden && (displaySignUpTooltip$ | async)"
            id="signup"
            (focusoutInfoToolTip)="closeSignUpTooltip()"
            style="position: absolute"
            [arrowPosition]="arrowPosition"
            [closeIcon]="closeEnable"
            [errorMessage]="tooltipSignUpContent"
            [icon]="false"
            [closeEscInfoToolTip]="true"
            data-test-error-tooltip="false"
          ></idp-error-tooltip>
        </div>

        <div
          #loginCodeContainer
          *ngSwitchCase="'login'"
          class="login-form-container"
          [ngClass]="{ 'd-flex': triggerLoginModal }"
        >
          <ng-container
            *ngIf="triggerLoginModal; then loginModal; else formPostToLoginBff"
          ></ng-container>
          <ng-template #loginModal>
            <button
              (click)="toggleModal(); setTrackingObject(item, $event)"
              id="login-modal-button"
              class="login-btn btn btn-danger login-modal-button"
            >
              {{ item.details?.loginLabel }}
            </button>

            <div
              *ngIf="showModal"
              class="container container-wrapper position-absolute"
              style="
                top: 0;
                left: 0;
                right: 0;
                display: flex;
                justify-content: flex-end;
              "
            >
              <!-- <idp-login-modal (hideModal)="toggleModal()"></idp-login-modal> -->
            </div>
          </ng-template>

          <ng-template #formPostToLoginBff>
            <form
              (ngSubmit)="onSubmitLogin(loginForm)"
              action="{{ item.details?.loginLink }}"
              class="form-inline"
              method="POST"
              name="loginForm"
              ngNoForm
            >
              <input [(ngModel)]="refreshURL" name="refreshURL" type="hidden" />
              <input
                [(ngModel)]="login_fromApp"
                name="login_fromApp"
                type="hidden"
              />
              <button
                #triggerElement
                (click)="setTrackingObject(item, $event); updateRefreshURL()"
                class="login-btn btn btn-danger"
                id="login-button"
              >
                {{ item.details?.loginLabel }}
              </button>
            </form>
          </ng-template>
          <idp-error-tooltip
            class="loginTooltip"
            [ngClass]="loginModalOff ? 'moveUp' : ''"
            (closeFullPopUp)="closeLoginTooltipPopup($event)"
            *ngIf="!isToolTipisHidden && (displayLoginTooltip$ | async)"
            id="login"
            style="position: absolute"
            (focusoutInfoToolTip)="closeLoginTooltip()"
            [arrowPosition]="arrowPosition"
            [closeIcon]="closeEnable"
            [errorMessage]="tooltipLoginContent"
            [icon]="false"
            data-test-error-tooltip="false"
          ></idp-error-tooltip>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="(isLoggedIn || isWarmState) && isReady">
  <div
    #triggerElement
    (click)="open($event)"
    (keydown)="openLoggedInFlyout($event)"
    [ngClass]="{
      'miles-available':
        milesLabel?.loggedInMilesLabel?.length > 6 ? true : false,
      'ddcfb-loggedIn': displayBusinessTypeSection
    }"
    class="logged-in-container logged-in-flyout"
    tabindex="0"
  >
    <div class="pl-0 pax-details">
      <span class="pax-name">
        {{
          getLoggedinDtls?.preferredName
            ? getLoggedinDtls?.preferredName
            : getLoggedinDtls?.firstName
        }}
      </span>
      <div>
        <span [ngClass]="getClassName(getLoggedinDtls?.membershipLevel)">
          {{ getLoggedinDtls?.smBalance | number }} {{ getLabelName() }}
        </span>
      </div>
      <!-- <div *ngIf="businessAccount"><span class="pax-miles-busimem">{{getLoggedinDtls?.smBalance | number}} {{ businessAccount ? milesLabel?.loggedInMilesLabelBusiness : milesLabel?.loggedInMilesLabel}}</span></div> -->
    </div>
    <span class="open-flyout icon-advsearchtriangle toggle-flyout"></span>
    <idp-error-tooltip
      id="accountrecoverytooltip"
      class="account-recovery-tooltip d-none"
      (closeFullPopUp)="closeAccountRecoveryTooltipPopup($event)"
      [arrowPosition]="arrowPosition"
      *ngIf="isLoggedIn && (displayAccountRecoveryTooltip$ | async)"
      [closeIcon]="closeEnable"
      (focusoutInfoToolTip)="closeAccountRecoveryTooltip()"
      [icon]="false"
      style="position: absolute"
      [errorMessage]="accountRecoveryTooltipHtml()"
      data-test-error-tooltip="false"
    ></idp-error-tooltip>
  </div>
</ng-container>
